import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { BillingInvoiceItemEditInfo } from '../../../../model/billing/billing-invoice-item-edit-info';
import { BillingIvoiceItemManualDialogComponent } from '../../../dialogs/billing-ivoice-item-manual-dialog/billing-ivoice-item-manual-dialog.component';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

export const BILLING_INVOICE_ITEM_MANUAL_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BillingInvoiceItemManualEditComponent),
  multi: true,
};

@Component({
  selector: 'app-billing-invoice-item-manual-edit',
  providers: [BILLING_INVOICE_ITEM_MANUAL_CONTROL_VALUE_ACCESSOR],
  templateUrl: './billing-invoice-item-manual-edit.component.html',
  styleUrls: ['./billing-invoice-item-manual-edit.component.css']
})
export class BillingInvoiceItemManualEditComponent implements ControlValueAccessor, OnInit {

  @Input() id: string;
  hideElement = true;
  onChange;
  loadingAction: boolean;
  items: BillingInvoiceItemEditInfo[];
  dataSource = new MatTableDataSource([]);
  @Input() noDeleteItem: boolean;
  displayedColumns: string[] = ['CompanyName', 'ServiceName',
                                'Amount', 'AliquotTax', 'Edit',
                                'Delete'];

  constructor( private dialog: MatDialog ) { }

  ngOnInit() {
  }

  writeValue(items: BillingInvoiceItemEditInfo[]): void {

    this.items = items;
    this.dataSource = new MatTableDataSource( this.items );
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState?(isDisabled: boolean): void {
  }

  changeBillingInvoiceItems(): void {

    if (this.onChange) {
      this.onChange( this.items );
    }
  }

  addNew() {
    this.editItem();
  }

  deleteItem( index: number ) {

    this.items.splice( index, 1 );
    this.dataSource = new MatTableDataSource( this.items );
    this.changeBillingInvoiceItems();
  }

  editItem( item: BillingInvoiceItemEditInfo = null) {

    const nuevo = item == null;

    const dialogRef = this.dialog.open(BillingIvoiceItemManualDialogComponent, {
      width: '50%',
      data: item
    });

    dialogRef.afterClosed().subscribe(async (result: BillingInvoiceItemEditInfo) => {

      if ( result ) {

        if ( nuevo ) {
            this.addNewItem(result);
        }

        this.dataSource = new MatTableDataSource( this.items );
        this.changeBillingInvoiceItems();

      }
    });
  }

  private addNewItem(result: BillingInvoiceItemEditInfo) {
    const index = this.items
      .findIndex(i => i.AliquotTax.Id === result.AliquotTax.Id &&
        i.ServiceId === result.ServiceId &&
        i.CompanyId === result.CompanyId &&
        i.BillingConceptId === result.BillingConceptId);
    if (index > -1) {
      this.items.splice(index, 1);
    }
    this.items.push(result);
  }
}
